<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <div>
            <label for="start-datepicker">Choose the start date</label>
            <b-form-datepicker
              id="start-datepicker"
              v-model="startDate"
              class="mb-2"
              @input="validateInputGetData()"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col>
          <div>
            <label for="end-datepicker">Choose the end date</label>
            <b-form-datepicker
              id="end-datepicker"
              v-model="endDate"
              class="mb-2"
              @input="validateInputGetData()"
            ></b-form-datepicker>
          </div>
        </b-col>
        <b-col>
          <div>
            <label for="ProjectPicker">Choose the project</label>
            <b-form-select
              id="example-datepicker"
              v-model="selectedProject"
              :options="projectOptions"
              class="mb-2"
              @change="validateInputGetData()"
            ></b-form-select>
          </div>
        </b-col>
      </b-row>
      <div v-if="loadingData == true">
        <b-spinner type="grow" variant="primary" label="Loading..."></b-spinner>
      </div>
      <div v-if="reportData != null">
        <b-row class="mt-3"
          ><b-col><h4>Summary Report Information</h4></b-col></b-row
        >
        <b-row>
          <b-col>Total Atendances</b-col>
          <b-col>{{ reportData.total_attendances }}</b-col>
          <b-col>Total Atendees</b-col>
          <b-col>{{ reportData.atendees.count }}</b-col>
          <b-col>Total Sessions</b-col>
          <b-col>{{ reportData.sessions.count }}</b-col>
        </b-row>
      </div>
    </b-container>
    <div class="mt-4" v-if="reportData != null">
      <b-button block v-b-toggle.accordion-1 variant="info"
        >Show Atendees</b-button
      >
      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <div>
          <b-table
            v-if="reportData != null"
            striped
            hover
            :items="reportData.atendees.attendee_list"
          ></b-table>
        </div>
      </b-collapse>

      <b-button block v-b-toggle.accordion-2 variant="info"
        >Show Sessions</b-button
      >
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <div>
          <b-table
            v-if="reportData != null"
            striped
            hover
            :items="reportData.sessions.session_list"
          ></b-table>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
export default {
  // This is a rough workthorough of a report using the report api
  created() {
    this.setUpStore();
    this.getProjectData();
  },
  computed: {
    reportData() {
      return this.$store.getters.reportData;
    },
    loadingData() {
      return this.$store.getters.loadingData;
    },
    atendee_items() {
      try {
        return this.reportData.atendees.atendee_list;
      } catch {
        return null;
      }
    },
  },

  data() {
    return {
      startDate: null,
      endDate: null,
      selectedProject: null,
      projectOptions: [],
      projectData: null,
      dates: null,
      items: null,
    };
  },
  methods: {
    setUpStore() {
      if (this.loadingData == true) {
        this.$store.commit("toggleLoadingData");
      }
      this.$store.commit("reportData", null);
    },
    getProjectData() {
      const url = this.$store.getters.urlPrefix + "api/projects_and_aliases/";
      this.$store
        .dispatch("genericGetApiCall", {
          mutationName: null,
          url: url,
        })
        .then((resolve) => {
          this.projectData = resolve;
          let item;
          for (item in resolve.results) {
            const value = resolve.results[item].aliases;
            const text = resolve.results[item].projectName;
            const selectItem = { value: value, text: text };
            this.projectOptions.push(selectItem);
          }
        });
    },

    getData() {
      const url =
        this.$store.getters.urlPrefix +
        "api/attendanceReport/?start_date=" +
        this.startDate +
        "&end_date=" +
        this.endDate +
        "&project_alias_id=" +
        this.selectedProject;
      this.$store.dispatch("genericGetApiCall", {
        mutationName: "reportData",
        url: url,
      });
    },

    validateInputGetData() {
      const today = new Date();
      const start_date = new Date(this.startDate);
      const end_date = new Date(this.endDate);

      if (start_date >= today) {
        alert("Start date must be in the past");
        this.startDate = null;
        return;
      }
      if (end_date > today) {
        alert("End date must be in the past");
        this.endDate = null;
        return;
      }
      if (this.endDate != null && start_date > end_date) {
        alert("Start date must be before or the same as end date");
        this.startDate = null;
        return;
      }
      if (this.selectedProject == null) {
        return;
      }
      if (
        this.selectedProject != null &&
        this.startDate != null &&
        this.endDate != null
      ) {
        this.getData();
      }
    },
  },
};
</script>

<style scoped></style>
